import { cn } from "@/lib/utils";

import type { CartItemProviderProps } from "./CartItem.context";
import { CartItemProvider } from "./CartItem.context";

type CartItemRootProps = CartItemProviderProps;

const CartItemRoot = ({ children, className, ...props }: CartItemRootProps) => {
  return (
    <CartItemProvider {...props}>
      <div
        className={cn(
          "border-gray-150 relative grid grid-flow-row-dense grid-cols-[auto_1fr] overflow-hidden border-b text-base leading-tight",
          className,
        )}
      >
        {children}
      </div>
    </CartItemProvider>
  );
};

CartItemRoot.displayName = "CartItemRoot";

export default CartItemRoot;
